import { useEffect, useRef } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { useCookieConsent } from '../../contexts/CookieConsentContext'
import { syncWebMeasurementOutcomes } from '../../lib/funnelMeasurement'
import { isWebMeasurementAllowed } from '../../lib/measurementPolicy'
import { retryPendingSignupAttribution } from '../../lib/signupAttribution'

/** Web-only relay. Native provider states remain operational records, never web conversions. */
export default function FunnelMeasurementRelay() {
  const { user } = useAuth()
  const { consent, analyticsReady } = useCookieConsent()
  const currentUser = useRef(user?.id)
  currentUser.current = user?.id

  useEffect(() => {
    if (!user) return
    // Retry only attribution carrying evidence of this newly created account.
    void retryPendingSignupAttribution(user)
  }, [user])

  useEffect(() => {
    if (
      !user ||
      !isWebMeasurementAllowed() ||
      (!analyticsReady && consent?.categories.marketing !== true)
    )
      return
    let cancelled = false
    const sync = () => {
      void syncWebMeasurementOutcomes(() => !cancelled && currentUser.current === user.id)
    }
    sync()
    const interval = window.setInterval(sync, 30_000)
    window.addEventListener('focus', sync)
    return () => {
      cancelled = true
      window.clearInterval(interval)
      window.removeEventListener('focus', sync)
    }
  }, [user, analyticsReady, consent])
  return null
}
